import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=db9a5eee&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db9a5eee"]])

export default __exports__